module.exports = __webpack_public_path__ + "img/logo.3385bcb5.svg";